import { z } from "zod";

import { env } from "@/env";

import { getAppLocale } from "./getAppLocale";

export function getAppBaseUrl(path?: string, options?: { locale?: string }) {
  const baseUrl = z.string().parse(env.NEXT_PUBLIC_APP_BASE_URL);

  return [baseUrl, getAppLocale(options?.locale), path]
    .filter(Boolean)
    .join("/");
}
